var map = {
	"./ARG.png": 7880,
	"./AUS.png": 6822,
	"./BEL.png": 2040,
	"./BRA.png": 8241,
	"./CAN.png": 5164,
	"./CMR.png": 205,
	"./COL.png": 9889,
	"./CRC.png": 9361,
	"./CRO.png": 2221,
	"./DEN.png": 7218,
	"./ECU.png": 373,
	"./EGY.png": 7068,
	"./ENG.png": 6182,
	"./ESP.png": 382,
	"./FRA.png": 7101,
	"./GER.png": 2047,
	"./GHA.png": 2644,
	"./IRN.png": 3971,
	"./ISL.png": 3174,
	"./JPN.png": 112,
	"./KOR.png": 5633,
	"./KSA.png": 5565,
	"./MAR.png": 1216,
	"./MEX.png": 4463,
	"./NED.png": 4188,
	"./NGA.png": 530,
	"./PAN.png": 4969,
	"./PER.png": 5248,
	"./POL.png": 9903,
	"./POR.png": 5458,
	"./QAT.png": 7628,
	"./RUS.png": 201,
	"./SEN.png": 357,
	"./SRB.png": 4696,
	"./SUI.png": 585,
	"./SWE.png": 4574,
	"./TBD.png": 34,
	"./TUN.png": 218,
	"./URU.png": 1151,
	"./USA.png": 5585,
	"./WAL.png": 3274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9882;